  <!-- Error screen shown when getOTCConfig API fails or configuration is not found -->
<div class="option-otc" *ngIf="getActiveStep() === beforeStep1Active">
  <f-alert variant="error" *ngIf="rootScope.activeCustTab?.otcData?.deliveryMethodConfigMiss">{{noConfigForDeliveryMethods}}</f-alert>
    <f-alert variant="error" *ngIf="rootScope.activeCustTab.otcData?.deliveryMethodApiFail">
      There was problem loading the data.<a href="javascript:void('0')" (click)="otcService.getOTCConfig()"
      class="btn-alert">Try again.</a> </f-alert>
</div>


 <!-- Stepper Header and container for all 3 steps -->
<div class="otc-panel" *ngIf="getActiveStep() !== beforeStep1Active">

  <!-- Stepper Header of OTC  -->
    <div class="otc-container">
      <div class="step-container flex justify-space-between">
          <span [class]="(getActiveStep() === onStep1Active || getActiveStep() === onStep2Active || getActiveStep() === onStep3Active) ? 'step-val active': 'step-val'">
            <span [class]="(getActiveStep() === onStep1Active || getActiveStep() === onStep2Active || getActiveStep() === onStep3Active) ? (rootScope.activeCustTab.otcData.deliveryMethodSDataMiss ? 'step-circle failure' : 'step-circle active'): 'step-circle'">   
          <span class="step-no"> <span *ngIf="(getActiveStep() === onStep1Active) && !rootScope.activeCustTab.otcData.deliveryMethodSDataMiss">1</span>
           <span *ngIf="( getActiveStep() === onStep2Active || getActiveStep() === onStep3Active)"> <f-icon icon-config='{"iconName": "check", "iconType": "solid", "iconSize": "s"}'></f-icon></span> 
                       <span *ngIf="rootScope.activeCustTab.otcData.deliveryMethodSDataMiss"> <f-icon icon-config='{"iconName": "xmark", "iconType": "light", "iconSize": "s"}'></f-icon></span> 

          </span></span>Select Delivery Method/Address</span>
          
                    <span [class]="(getActiveStep() === onStep2Active || getActiveStep() === onStep3Active) ? 'step-val active': 'step-val'">
          <span [class]="(getActiveStep() === onStep2Active || getActiveStep() === onStep3Active) ? ( (rootScope.activeCustTab.otcData.notEligiblePhoneNumber) || (rootScope.activeCustTab.otcData.otcDenied) ? 'step-circle failure' : 'step-circle active'): 'step-circle'">
          <span class="step-no"><span *ngIf="!rootScope.activeCustTab.otcData.notEligiblePhoneNumber && !rootScope.activeCustTab.otcData.otcDenied && !rootScope.activeCustTab.otcData.sendOTCSuccess">2</span>  
          <span *ngIf="rootScope.activeCustTab.otcData.sendOTCSuccess"> <f-icon icon-config='{"iconName": "check", "iconType": "solid", "iconSize": "s"}'></f-icon></span> 
    
            <span *ngIf="(rootScope.activeCustTab.otcData.notEligiblePhoneNumber) || (rootScope.activeCustTab.otcData.otcDenied)"> <f-icon icon-config='{"iconName": "xmark", "iconType": "light", "iconSize": "s"}'></f-icon></span> 
          </span></span>Confirm and Send</span> 
  
         <span [class]="getActiveStep() === onStep3Active ? 'step-val active': 'step-val'">
          <span [class]="getActiveStep() === onStep3Active ? ( (rootScope.activeCustTab.otcData.otcExpired) || (rootScope.activeCustTab.otcData.validateOtcLocked) ? 'step-circle failure' : 'step-circle active'): 'step-circle'">
          <span class="step-no"><span *ngIf="!rootScope.activeCustTab.otcData.validateOtcLocked && !rootScope.activeCustTab.otcData.otcExpired">3</span>      
            <span *ngIf="(rootScope.activeCustTab.otcData.otcExpired) || (rootScope.activeCustTab.otcData.validateOtcLocked)"> <f-icon icon-config='{"iconName": "xmark", "iconType": "light", "iconSize": "s"}'></f-icon></span> 
          </span></span> Validate OTC </span> 
      </div>
    </div> 
  </div>

 <!-- Step 1 Where User choose Select Delivery Method/Address -->
 <div class="email-deliver-method" *ngIf="getActiveStep() === onStep1Active">
  <p class="pin-content">
    Choose a delivery method:
  </p>

  <f-alert variant="error" *ngIf="rootScope.activeCustTab.otcData.deliveryMethodSDataMiss" >
    {{rootScope.activeCustTab.otcInsideFTU.hasAccountBalance ? noMobileNumberAvailableFtuOtcMsg  : noDataOnFile }}
 </f-alert>

<div *ngFor="let method of rootScope.activeCustTab.otcData?.otcConfigData?.deliveryMethods">

  <h6 *ngIf="method?.details?.length > 0" class="method-type">{{ method.type | titlecase }}</h6>

  <mat-radio-group color="primary" class="account-selection text-indent" disableRipple aria-label="Select an option"
    [(ngModel)]="rootScope.activeCustTab.otcData.selectedDeliveryMethod.details" (change)="onSelectionChange(method.type, $event.value)">

    <div *ngFor="let detail of (method?.details || [])">
      <mat-radio-button [value]="detail" >
        {{getDisplayOption(detail)}}
      </mat-radio-button>
    </div>
    <!-- Below code to be used by FE CCR3-13754 starts -->
     <div class="hide">
      <f-alert variant="error" class="status-msg"><p>Failed to remove the STOP status for the selected phone number.</p><p>Error detail- Invalid Country Code</p></f-alert>
      <p>Select the number where the One-time Code will be sent.</p>
      <p>Do not read any of the numbers below to the customer. The customer must provide and verify the number below, then you may select.</p>
     </div>
    <div *ngFor="let detail of (method?.details || [])" class="text-stopped-row hide">
      <mat-radio-button [value]="detail" class="text-stopped-radio">
        {{getDisplayOption(detail)}} (<span class="red"><strong>Text Stopped</strong></span>)
      </mat-radio-button>
      <span class="text-stopped-msg">Text messaging was previously stopped to this phone number. <a href="javascript:void(0)">Click here</a> to receive text messages again.</span>
    </div>
    <!-- CCR3-13754 ends -->
  </mat-radio-group>
</div>
  <div class="btn-controls">                    
    <f-button text="Continue" title="Continue" (click)="continueOnStep1()" [ngClass]="{'disableBtn': isSelectedDeliveryMethodEmpty()}"[disabled]="isSelectedDeliveryMethodEmpty()" type="button" variant="progressive" class=""></f-button>
  </div>
</div>

   <!-- Step 2 Confirm & Send  -->
  <div class="confirm-send" *ngIf="getActiveStep() === onStep2Active && !rootScope.activeCustTab.otcData.sendOTCSuccess">
      <f-alert variant="error" *ngIf="rootScope.activeCustTab.otcData.notEligiblePhoneNumber" class="status-msg">{{notEligibleErrMsg}}</f-alert>
      <f-alert variant="error" *ngIf="rootScope.activeCustTab.otcData.otcDenied" class="status-msg">{{deniedErrMsg}}</f-alert>
      <f-alert variant="error" *ngIf="rootScope.activeCustTab.otcData.generateOTCApiFailure" class="status-msg">{{generateOtcApiFailErrMsg}}</f-alert>
    <p class="pin-content" *ngIf="!rootScope.activeCustTab.otcData.notEligiblePhoneNumber && !rootScope.activeCustTab.otcData.otcDenied">
      The one-time code will be sent to: <strong>{{rootScope.activeCustTab.otcData.selectedDeliveryMethod?.type !== 'email' ? rootScope.activeCustTab.otcData?.selectedCountryCode : ''}} {{rootScope.activeCustTab.otcData.selectedDeliveryMethod?.type === 'email' ? rootScope.activeCustTab.otcData?.selectedEmail : rootScope.activeCustTab.otcData?.selectedPhoneNumber}}</strong>.   
    </p>

    <div class="btn-controls">
      <f-button text="Back" title="Back" (click)="backToStep1()" type="button" variant="action" class=""></f-button>
      <f-button text="Send OTC" title="Send OTC" type="button" 
      [ngClass]="{'disableBtn': (rootScope.activeCustTab.otcData.otcDenied) || (rootScope.activeCustTab.otcData.notEligiblePhoneNumber) || (rootScope.activeCustTab.otcData.generateOTCInProgress)}"  
      (click)="otcService.generateOTC()"variant="progressive"
       [disabled]="(rootScope.activeCustTab.otcData.otcDenied) || (rootScope.activeCustTab.otcData.notEligiblePhoneNumber) || (rootScope.activeCustTab.otcData.generateOTCInProgress)"></f-button>
    </div>
  </div>
  
    <!-- Step 3 Enter OTC and Validate  -->
<div class="enter-otc" *ngIf="rootScope.activeCustTab.otcData.sendOTCSuccess">
         <div class="status-msg" *ngIf="!verifyCodeClicked && !rootScope.activeCustTab.otcData.validateOtcLocked && !rootScope.activeCustTab.otcData.validateOtcFail && !rootScope.activeCustTab.otcData.validateOtcApiFailure && !rootScope.activeCustTab.otcData.otcExpired">
        <f-alert variant="success" class="status-msg">Success! The One-Time Code has been sent.</f-alert>
         </div>
        <div class="success-msg" *ngIf="rootScope.activeCustTab.otcData.validateOtcLocked">
          <f-alert variant="error" class="status-msg">{{accountLockedMsg}}</f-alert>
        </div> 
        <div class="success-msg" *ngIf="rootScope.activeCustTab.otcData.validateOtcFail">
          <f-alert variant="error" class="status-msg">{{invalidOTCMsg}}</f-alert>
        </div>
        <div class="success-msg" *ngIf="rootScope.activeCustTab.otcData.validateOtcApiFailure">
          <f-alert variant="error" class="status-msg">{{validateOtcApiFailureMsg}}</f-alert>
        </div>  
        <div class="success-msg" *ngIf="rootScope.activeCustTab.otcData.otcExpired">
          <f-alert variant="error" class="status-msg">{{otcExpiredMsg}}</f-alert>
        </div> 

    <ul>
      <li >The One-Time Code has been sent to:<strong>{{rootScope.activeCustTab.otcData.selectedDeliveryMethod?.type !== 'email' ? rootScope.activeCustTab.otcData?.selectedCountryCode : ''}} {{rootScope.activeCustTab.otcData.selectedDeliveryMethod?.type === 'email' ? rootScope.activeCustTab.otcData?.selectedEmail : rootScope.activeCustTab.otcData?.selectedPhoneNumber}}</strong></li>
      <li>The One-Time Code is only valid for <strong>10 minutes </strong>. Once the code has been received by the customer, enter the code in the box below and click Verify Code.</li>        
    </ul>

  <div class="container">
    <div class="row">
    </div>
    <div class="row">
      <div class="col-md-6">
          <mat-form-field appearance="fill" class="component-box">
            <mat-label>One-Time Code</mat-label>
            <input
              [formControl]="otcService.oneTimeCode"
              matInput
              id="nid"
              placeholder="Enter {{otcService.otcLenght}}-digit code"
            />
            <mat-error *ngIf="otcService.oneTimeCode.hasError('required')">
              <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon> Code is required
            </mat-error>
            <mat-error *ngIf="otcService.oneTimeCode.hasError('pattern')">
              <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon> Invalid format, try again.
            </mat-error>
            <mat-error *ngIf="otcService.oneTimeCode.hasError('minlength') && !otcService.oneTimeCode.hasError('pattern')">
              <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon> Code must be {{otcService.otcLenght}} characters
            </mat-error>
            <mat-error *ngIf="otcService.oneTimeCode.hasError('maxlength') && !otcService.oneTimeCode.hasError('pattern')">
              <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon> Code must be {{otcService.otcLenght}} characters
            </mat-error>
          </mat-form-field>
          
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="btn-controls">                  
          <f-button text="Cancel" title="Cancel" type="button" (click)="backToStep1()" variant="action" class=""></f-button>
          <f-button text="Verify Code" title="Verify Code" [ngClass]="{'disableBtn': otcService.oneTimeCode?.invalid || rootScope.activeCustTab.otcData.validateOtcLocked || rootScope.activeCustTab.otcData.validateOTCApiProcessing || rootScope.activeCustTab.otcData.otcExpired}" [disabled]="otcService.oneTimeCode?.invalid || rootScope.activeCustTab.otcData.validateOtcLocked || rootScope.activeCustTab.otcData.validateOTCApiProcessing || rootScope.activeCustTab.otcData.otcExpired" 
          variant="progressive" (click)="verifyCode()" type="button"></f-button>

        </div>
      </div>
    </div>
  </div>
</div>